import { getParsedJSON } from "../utils/getParsedJSON.util";
import StoryblokEntryTemplateContext from "../interfaces/Storyblok/StoryblokEntryTemplateContext.interface";

const getPageContext = (context: any): StoryblokEntryTemplateContext => {
  return {
    ...context,
    content: getParsedJSON(context.content),
  };
};

export default getPageContext;
